import React, { lazy, useEffect } from "react";
import { useUser } from "reactfire";
import { useUserProfile } from "./components/hooks/firestore/useUserProfile";
import { auth } from "./services/firebase";
import { signOut } from "firebase/auth";
import {
  hasWebshopAccess,
  isWebshopAccessRefused,
} from "./helpers/cmsAccount";

const LoginRegister = lazy(() => import("./pages/other/LoginRegister"));

// React Router v6 compatible PrivateRoute.
// Usage in routes: <Route path={...} element={<PrivateRoute element={<YourComponent />} />} />
const PrivateRoute = ({ element, detailPage = false }) => {
  const { data: authUser, status: authStatus } = useUser();
  const { data: profile, isLoading: profileLoading } = useUserProfile();
  const isAuthenticated =
    authStatus === "success" && !!authUser && !!authUser.uid;
  const authorizationLoaded = !profileLoading;
  const isAuthorized = authorizationLoaded && hasWebshopAccess(profile);

  useEffect(() => {
    // Only judge the profile of the signed-in user, never the placeholder
    // document that is read while nobody (or someone else) is signed in
    if (
      !!profile &&
      !!authUser &&
      profile.uid === authUser.uid &&
      isWebshopAccessRefused(profile)
    )
      signOut(auth);
  }, [profile, authUser]);

  // In v6 we simply return the element to render.
  const Allowed = authorizationLoaded ? (
    isAuthenticated && isAuthorized ? (
      element
    ) : (
      <LoginRegister />
    )
  ) : isAuthenticated ? (
    element
  ) : (
    <LoginRegister />
  );

  return Allowed;
};

export default PrivateRoute;
